import { Button, ErrorBoundary as OriginalErrorBoundary } from "matsuri-ui"
import { css } from "@emotion/react"
import React, { ErrorInfo, useState } from "react"
import { useTranslation } from "@/hooks/useTranslation"

const ErrorFallback = ({
    error
}: {
    error?: { error: Error; errorInfo: ErrorInfo }
}) => {
    const { t } = useTranslation()
    return (
        <div
            css={css`
                max-width: 1024px;
                padding: 48px 5vw 0px;
                margin: auto;
                & > * {
                    margin-bottom: 16px;
                }
            `}
        >
            <header>
                <h2>{t("エラーが発生しました")}</h2>
            </header>
            <div>
                <p>
                    {t(
                        "サポートが必要な場合は、以下のデータをコピーして開発者に発生状況などと共に送付してください。"
                    )}
                </p>
            </div>
            <textarea
                css={css`
                    width: 100%;
                    min-height: 200px;
                    border: 1px solid black;
                `}
                value={JSON.stringify({
                    ...error,
                    // jsのErrorはseriarizeできないので文字列化
                    error: `${error?.error}`
                })}
                readOnly
            />
            <div>
                <Button
                    css={css`
                        float: right;
                    `}
                    variant="filled"
                    color="primary"
                    onClick={() => {
                        window.location.reload()
                    }}
                >
                    {t("元のページに戻る")}
                </Button>
            </div>
        </div>
    )
}

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
    const [error, setError] = useState<{
        error: Error
        errorInfo: ErrorInfo
    }>()
    return (
        <OriginalErrorBoundary
            onError={setError}
            fallback={<ErrorFallback error={error} />}
        >
            {children}
        </OriginalErrorBoundary>
    )
}
